import { render } from "./GridNote.vue?vue&type=template&id=71cb9b9d"
import script from "./GridNote.vue?vue&type=script&lang=js"
export * from "./GridNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__